import React, {Component} from "react";
import {field, Loader, utils} from "@mc/mc-legacy";
import {connect} from "react-redux";
import * as fieldActions from "../../actions/fieldActions";
import PropTypes from "prop-types";

/**
 * field pro filtr čipování Ma
 */

class ApprovalConfigField extends Component {
    static propTypes = {
        empty: PropTypes.bool,
    };
    static defaultProps = {
        empty: true,
    };

    componentDidMount() {
        this.fetchData(true);
    }

    UNSAFE_componentWillReceiveProps() {
        this.fetchData();
    }

    fetchData = (force = false) => {
        this.props.dispatch(fieldActions.fetchApprovalConfigurationsList(force));
    };

    render() {
        const { store, empty, ...componentProps } = this.props;

        if (store.fetching) {
            return <Loader />;
        }

        return (
            <field.Autocomplete
                {...componentProps}
                useIdAsValue
                getItemId={(item) => (item ? item.code : "")}
                getItemName={(item) => (item ? item.name : "")}
                items={store.rows.sort((a, b) => a.name.localeCompare(b.name))}
            />
        );
    }
}

export default connect((state) => {
    return {
        store: utils.storeFromArea(state, fieldActions.APPROVAL_CONFIGURATIONS_LIST),
    };
})(ApprovalConfigField);
